export default function parallaxEffect() {
  const $section = $('.manualEventFeed-eventCards-container .parallax-section.main-effect');

  if (!$section.length) return;

  const el = $section[0];

  const observer = new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting) {
        $(globalThis).on('scroll.parallax', function () {
          const scrollPos = $(globalThis).scrollTop();
          const cardOffset = $section.offset().top;
          const windowHeight = $(globalThis).height();

          const parallaxScroll = cardOffset - scrollPos - windowHeight;

          $section.css({
            transform: `translateY(${-parallaxScroll * 0.1}px)`,
          });
        });

        observer.disconnect();
      }
    },
    {
      threshold: 0,
    },
  );

  observer.observe(el);
}
